import { useContext, useEffect, useState } from 'react';
import io from 'socket.io-client';

// CONTEXT
import { AuthContext } from 'context/AuthContext';

// withCredentials : sans lui le cookie de session ne part pas à la poignée de
// main, et le serveur ne sait pas qui se connecte.
const socket = io(process.env.REACT_APP_API_URL, { withCredentials: true });

export function useSocket() {
    const { email } = useContext(AuthContext);
    const [connectedUsers, setConnectedUsers] = useState(0);

    useEffect(() => {
        // Confirmation de la connexion
        socket.on('connected', (data) => {
            // ...
        });

        // L'email n'est plus transmis : le serveur le lit dans la session.
        if (email) {
            socket.emit('user_connected');
        }

        const handleUserCountUpdate = (data) => {
            setConnectedUsers(data.count);
        };

        socket.on('update_user_count', handleUserCountUpdate);

        return () => {
            socket.off('connected');
            socket.off('update_user_count', handleUserCountUpdate);
        };
    }, [email]);

    return { socket, connectedUsers };
}